var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg_(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 530,
    viewBox: "0 0 530 530",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_218_10943)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 530,
    height: 530,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.584 298.934C396.003 228.307 339.953 209.55 313 209L327.026 263.455C381.812 254.874 389 319.5 383.957 545.699H404.584C412.505 497.514 407.884 331.112 404.584 298.934Z",
    fill: "white",
    stroke: "#1C1B1F",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.492 75.0299C379.798 123.71 341.845 197.142 310.492 223.544C340.855 244.666 323.143 271.399 310.492 282.126C373.198 310.508 364.672 373.709 352.571 401.762C323.528 477.67 253.011 464.743 221.383 448.792C63.6278 349.122 110.547 187.791 153.727 119.584C203.891 40.3765 279.139 56.8781 310.492 75.0299Z",
    fill: "#D9D9D9",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.314 225.625C370.579 155.318 338.783 104.681 318.831 90C333.762 150.631 301.446 191.493 283.594 203.049C265.418 184.989 228.958 186.386 213 189.343C304.529 233.849 259.792 294.426 225.983 319.151C247.405 326.892 271.152 312.701 280.348 304.639C291.384 305.284 307.126 320.495 313.617 328.02C342.828 368.656 311.024 437.161 269.386 457.887C305.819 459.614 319.027 441.166 327.411 433.641C389.729 351.08 339.312 300.339 306.314 285.288C340.719 258.198 320.649 234.225 306.314 225.625Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 105,
    r: 27,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 185,
    cy: 146,
    r: 14,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_218_10943"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 530,
    height: 530,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg_);
export default __webpack_public_path__ + "static/media/일반외과_요로결석.d46f9fb4630d441f3302b2d4d2838f0b.svg";
export { ForwardRef as ReactComponent };